import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  MenuItem, Select, FormControl, InputLabel,
} from '@material-ui/core';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { usePortfolioStateContext } from 'Components/UI/Portfolio/PortfolioContext';

const styles = () => ({
  root: {},
  menu: {},
});

function RecommendedPortfolioSelect({
  classes,
  className,
  selectedPortfolioName,
  setSelectedPortfolioName,
}) {
  const { portfolioCollection, loading } = usePortfolioStateContext();
  const [portfolio] = portfolioCollection || [];

  const PortfolioMenuItems = () => (portfolio ? (portfolio
    .attr('recommended')
    .resources()
    .list()
    .map((p) => {
      // Generate the menu items
      return (
        <MenuItem
          disabled={loading}
          value={p.attr('name')}
          onClick={(e) => {
            e.preventDefault();
            setSelectedPortfolioName(p.attr('name'));
          }}
        >
          {p.attr('name')}
        </MenuItem>
      );
    })
  ) : (
    <MenuItem disabled>No Portfolios</MenuItem>
  ));

  return (
    <FormControl className={classNames(classes.root, className)}>
      <InputLabel className={classes.label}>{selectedPortfolioName}</InputLabel>
      <Select
        className={classes.root}
        helperText="Recommended Portfolio"
        name="Recommended Portfolio"
        fullWidth
        value={selectedPortfolioName}
      >
        <PortfolioMenuItems />
      </Select>
    </FormControl>
  );
}

RecommendedPortfolioSelect.defaultProps = {
  className: '',
};

RecommendedPortfolioSelect.propTypes = {
  setSelectedPortfolioName: PropTypes.func.isRequired,
  selectedPortfolioName: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
};

export default withStyles(styles)(RecommendedPortfolioSelect);
